import React, { useState } from "react";

export default function AdminLogin({ onLoginSuccess }) {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    try {
      const response = await fetch("https://api.mykcertifiedtranslations.com/api/admin/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success && data.token) {
        localStorage.setItem("adminToken", data.token);
        onLoginSuccess(data.token);
      } else {
        setErrorMessage(data.message || "Login failed.");
      }
    } catch (error) {
      setErrorMessage("Server error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="section light-section" id="admin-inquiries">
      <div className="container admin-login-container">
        <div className="admin-login-box">
          <span className="section-label">Admin Access</span>
          <h2>Admin Login</h2>
          <p>Please enter your admin credentials to view translation requests.</p>

          <form className="admin-login-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
            />

            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
            />

            <button type="submit" className="btn btn-primary" disabled={isLoading}>
              {isLoading ? "Signing in..." : "Sign In"}
            </button>

            {errorMessage && <p className="admin-login-error">{errorMessage}</p>}
          </form>
        </div>
      </div>
    </section>
  );
}
